<template>
	<div>
        <v-container>
           <v-row>
               <v-col cols="4" >
                   <v-card height="125">
                       <v-card-title>
                           <p class="ma-0 pa-0 titulo">QUANTIDADE DE PEDIDOS</p>
                       </v-card-title>
                       <v-card-text  class="text-right">
                           <p class="contagemPedidos">{{contagemPedidos}}</p>
                       </v-card-text>
                   </v-card>
               </v-col>
               <v-col cols="4">
                   <v-card height="125">
                       <v-card-title>
                           <p class="ma-0 pa-0 titulo">PEDIDOS HOJE</p>
                       </v-card-title>
                       <v-card-text  class="text-right">
                           <p class="contagemPedidos">{{contagemPedidosHoje}}</p>
                       </v-card-text>
                   </v-card>
               </v-col>
               <v-col cols="4">
                   <v-card height="125">
                       <v-card-title>
                           <p class="ma-0 pa-0 titulo">QUANTIDADE DE CATALOGOS</p>
                       </v-card-title>
                       <v-card-text  class="text-right">
                           <p class="contagemPedidos">{{contagemCatalogos}}</p>
                       </v-card-text>
                   </v-card>
               </v-col>
           </v-row>
        </v-container>
    </div>
</template>
<script>
	export default {
		props: ['dashboard'],
		data: () => ({
            qtd: ''
        }),
        computed: {
            contagemCatalogos() { return `000${this.dashboard.catalogos}`.substr(-3) },
            contagemPedidos() { return `000${this.dashboard.pedidos}`.substr(-3) },
            contagemPedidosHoje() { return `000${this.dashboard.pedidosHoje}`.substr(-3) },
        }
	}
</script>
<style>
    .titulo {
        font-weight: 300;
        font-size: 16px;
        padding: 0%;
        margin: 0%;
    }
    .contagemPedidos {
        font-weight: 700;
        font-size: 43px;
        padding: 0%;
        margin: 0%;
    }
</style>